import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
// internal
import { CustomerLocationModel } from 'src/app/models/customers/location';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
import { OfflineDataService } from 'src/packages/mitsBasics';

@Injectable({
  providedIn: 'root',
})
export class LocationMachineService extends OfflineDataService<CustomerLocationModel> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'Customers::LocationMachine',
      http,
      errorService,
      events,
      'customers/locations/',
      'location',
      ['created_at', 'updated_at'],
      [],
      'parent_location_id'
    );
    this.bulkSyncActive = true;
  }
}
